import Page from '~/pages/page';

export default class GenericIndex extends Page {
    constructor(...args) {
        super(...args);
    }

    // init() {
    //     super.init();
    // }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}
